import type { BoxProps} from '@chakra-ui/react'
import { Flex } from '@chakra-ui/react'
import type { MouseEventHandler } from 'react'
import React from 'react'
import { Note } from '../../icons'


export const InsuranceInfoNote = ({
  children, sx, onClick, ...rest
}: {
  children: React.ReactNode;
  sx?: BoxProps;
  onClick?: MouseEventHandler<HTMLDivElement> | undefined;
}) => {
  return (
    <Flex sx={{ gap: 2, alignItems: 'center', fontSize: 'sm', ...sx }} onClick={onClick} {...rest}>
      <Note color="secondary.500" />

      {children}
    </Flex>
  )
}
